import type { IncidentsResponse } from 'apis/admins/incidents/incidents_response_type';

type Props = Required<{
  incidents: IncidentsResponse[];
}>;

export const IncidentsArea = ({ incidents }: Props) => {
  return (
    <>
      {incidents.length > 0 && (
        <div className="alert alert-solid alert-warning mg-b-0">
          {incidents.map((incident: IncidentsResponse) => (
            <p
              className="pd-0 mg-0 white-space-pre-wrap"
              key={`${incident.id}-${incident.message}`}
            >
              {incident.message}
            </p>
          ))}
        </div>
      )}
      <style>
        {/* FIXME: refine */}
        {`
          .white-space-pre-wrap {
            white-space: pre-wrap;
          }
        `}
      </style>
    </>
  );
};
